module.exports = __webpack_public_path__ + "5a37bd793e620a11737698a5c8b9223c.MP3";